<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Review Project Info
        </p>
      </header>
      <section class="modal-card-body">
        <div class="flex -mx-5 my-4">
          <d-field label="Current Project Number" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.number" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.number = newSubmittedInfo.number" />
            </d-tooltip>
          </div>
          <d-field label="Existing Project Number" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.number" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Project Name" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.name" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.name = newSubmittedInfo.name" />
            </d-tooltip>
          </div>
          <d-field label="Existing Project Name" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.name" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Status at Registration" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.statusAtRegistration" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.statusAtRegistration = newSubmittedInfo.statusAtRegistration" />
            </d-tooltip>
          </div>
          <d-field label="Existing Status at Registration" class="w-5/12 px-5">
            <d-select v-model="newExistingInfo.statusAtRegistration" expanded>
              <option value="Architectural Design">
                Architectural Design
              </option>
              <option value="Construction (Not Woodwork)">
                Construction (Not Woodwork)
              </option>
              <option value="Bidding (Woodwork)">
                Bidding (Woodwork)
              </option>
              <option value="Pre-fabrication (Woodwork)">
                Pre-fabrication (Woodwork)
              </option>
              <option value="Shop Drawings (Woodwork)">
                Shop Drawings (Woodwork)
              </option>
              <option value="Fabrication (Woodwork)">
                Fabrication (Woodwork)
              </option>
              <option value="Installation (Woodwork)">
                Installation (Woodwork)
              </option>
            </d-select>
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Type" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.type" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.type = newSubmittedInfo.type" />
            </d-tooltip>
          </div>
          <d-field label="Existing Type" class="w-5/12 px-5">
            <d-select v-model="newExistingInfo.type" expanded>
              <option value="Residential/1&2 Family/Customer Home">
                Residential/1&2 Family/Customer Home
              </option>
              <option value="Residential/1&2 Family/Sale-Spec Home">
                Residential/1&2 Family/Sale-Spec Home
              </option>
              <option value="Residential/Apartment-Condo/1-3 Story">
                Residential/Apartment-Condo/1-3 Story
              </option>
              <option value="Residential/Apartment-Condo/4+ Story">
                Residential/Apartment-Condo/4+ Story
              </option>
              <option value="Residential/Elderly-Assisted Living">
                Residential/Elderly-Assisted Living
              </option>
              <option value="Non-Res/Commercial/Office">
                Non-Res/Commercial/Office
              </option>
              <option value="Non-Res/Commercial/Bank">
                Non-Res/Commercial/Bank
              </option>
              <option value="Non-Res/Commercial/Food - Beverage">
                Non-Res/Commercial/Food - Beverage
              </option>
              <option value="Non-Res/Commercial/Grocery">
                Non-Res/Commercial/Grocery
              </option>
              <option value="Non-Res/Commercial/Retail">
                Non-Res/Commercial/Retail
              </option>
              <option value="Non-Res/Commercial/Shopping Center-Strip">
                Non-Res/Commercial/Shopping Center-Strip
              </option>
              <option value="Non-Res/Commercial/Regional Mall">
                Non-Res/Commercial/Regional Mall
              </option>
              <option value="Non-Res/Transport/Airline Terminal">
                Non-Res/Transport/Airline Terminal
              </option>
              <option value="Non-Res/Transport/Passenger Terminal">
                Non-Res/Transport/Passenger Terminal
              </option>
              <option value="Non-Res/Transport/Aircraft Sales-Svc.">
                Non-Res/Transport/Aircraft Sales-Svc.
              </option>
              <option value="Non-Res/Transport/Vehicle Sales-Svc.">
                Non-Res/Transport/Vehicle Sales-Svc.
              </option>
              <option value="Non-Res/Transport/Parking Garage">
                Non-Res/Transport/Parking Garage
              </option>
              <option value="Non-Res/Industrial/Gas-Chemical Plant">
                Non-Res/Industrial/Gas-Chemical Plant
              </option>
              <option value="Non-Res/Industrial/Refinery">
                Non-Res/Industrial/Refinery
              </option>
              <option value="Non-Res/Industrial/Warehouse">
                Non-Res/Industrial/Warehouse
              </option>
              <option value="Non-Res/Industrial/Warehouse (Refrigrt'd)">
                Non-Res/Industrial/Warehouse (Refrigrt'd)
              </option>
              <option value="Non-Res/Industrial/Manufacturing Bldg.">
                Non-Res/Industrial/Manufacturing Bldg.
              </option>
              <option value="Non-Res/Industrial/Freight Terminal">
                Non-Res/Industrial/Freight Terminal
              </option>
              <option value="Non-Res/Education/Library">
                Non-Res/Education/Library
              </option>
              <option value="Non-Res/Education/Primary School">
                Non-Res/Education/Primary School
              </option>
              <option value="Non-Res/Education/Middle-Senior HS">
                Non-Res/Education/Middle-Senior HS
              </option>
              <option value="Non-Res/Education/College-University">
                Non-Res/Education/College-University
              </option>
              <option value="Non-Res/Education/Vocational School">
                Non-Res/Education/Vocational School
              </option>
              <option value="Non-Res/Education/Misc. Edu. Building">
                Non-Res/Education/Misc. Edu. Building
              </option>
              <option value="Non-Res/Education/Kindergarten">
                Non-Res/Education/Kindergarten
              </option>
              <option value="Non-Res/Education/Pre-School">
                Non-Res/Education/Pre-School
              </option>
              <option value="Non-Res/Recreation/Casino">
                Non-Res/Recreation/Casino
              </option>
              <option value="Non-Res/Recreation/Theater-Auditorium">
                Non-Res/Recreation/Theater-Auditorium
              </option>
              <option value="Non-Res/Recreation/Stadium">
                Non-Res/Recreation/Stadium
              </option>
              <option value="Non-Res/Recreation/Museum">
                Non-Res/Recreation/Museum
              </option>
              <option value="Non-Res/Recreation/Convention-Exhibit Ctr">
                Non-Res/Recreation/Convention-Exhibit Ctr
              </option>
              <option value="Non-Res/Recreation/Athletic Facility">
                Non-Res/Recreation/Athletic Facility
              </option>
              <option value="Non-Res/Recreation/Swimming Pool">
                Non-Res/Recreation/Swimming Pool
              </option>
              <option value="Non-Res/Recreation/Social Club">
                Non-Res/Recreation/Social Club
              </option>
              <option value="Non-Res/Recreation/Beach-Marina Facility">
                Non-Res/Recreation/Beach-Marina Facility
              </option>
              <option value="Non-Res/Recreation/Bowling Alley">
                Non-Res/Recreation/Bowling Alley
              </option>
              <option value="Non-Res/Recreation/Misc. Recreation">
                Non-Res/Recreation/Misc. Recreation
              </option>
              <option value="Non-Res/Recreation/Indoor Arena">
                Non-Res/Recreation/Indoor Arena
              </option>
              <option value="Non-Res/Pub Bldgs/Captl-Crt hs-City Hall">
                Non-Res/Pub Bldgs/Captl-Crt hs-City Hall
              </option>
              <option value="Non-Res/Pub Bldgs/Post Office">
                Non-Res/Pub Bldgs/Post Office
              </option>
              <option value="Non-Res/Pub Bldgs/Fire-Police Station">
                Non-Res/Pub Bldgs/Fire-Police Station
              </option>
              <option value="Non-Res/Pub Bldgs/Prison-Jail">
                Non-Res/Pub Bldgs/Prison-Jail
              </option>
              <option value="Non-Res/Medical/Hospital">
                Non-Res/Medical/Hospital
              </option>
              <option value="Non-Res/Medical/Hospital">
                Non-Res/Medical/Hospital
              </option>
              <option value="Non-Res/Medical/Clinic-Medical Office">
                Non-Res/Medical/Clinic-Medical Office
              </option>
              <option value="Non-Res/Medical/Nursing-Medical Office">
                Non-Res/Medical/Nursing-Medical Office
              </option>
              <option value="Non-Res/Laboratories">
                Non-Res/Laboratories
              </option>
              <option value="Non-Res/Hotels-Motels">
                Non-Res/Hotels-Motels
              </option>
              <option value="Non-Res/Dormitories">
                Non-Res/Dormitories
              </option>
              <option value="Non-Res/Federal Facility/Military Facility">
                Non-Res/Fenderal Facility/Military Facility
              </option>
              <option value="Non-Res/Federal Facility/Space Facility">
                Non-Res/Fenderal Facility/Space Facility
              </option>
              <option value="Non-Res/Animal-Plant-Fish Facility">
                Non-Res/Animal-Plant-Fish Facility
              </option>
              <option value="Non-Res/Communications Building">
                Non-Res/Communications Building
              </option>
              <option value="Non-Res/Religous/Worship Facility">
                Non-Res/Religous/Worship Facility
              </option>
              <option value="Non-Res/Religous/Funeral-Internment">
                Non-Res/Religous/Funeral-Internment
              </option>
              <option value="Non-Res/Religous/other">
                Non-Res/Religous/other
              </option>
              <option value="Civil & Utility Buildings">
                Civil & Utility Buildings
              </option>
            </d-select>
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted City" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.city" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.city = newSubmittedInfo.city" />
            </d-tooltip>
          </div>
          <d-field label="Existing City" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.city" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted State" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.stateProvince" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.stateProvince = newSubmittedInfo.stateProvince" />
            </d-tooltip>
          </div>
          <d-field label="Existing State" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.stateProvince" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Country" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.country" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.country = newSubmittedInfo.country" />
            </d-tooltip>
          </div>
          <d-field label="Existing Country" class="w-5/12 px-5">
            <d-input v-model="newExistingInfo.country" />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Standards" class="w-5/12 px-5">
            <d-input v-model="newSubmittedInfo.standards" disabled />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.standards = newSubmittedInfo.standards" />
            </d-tooltip>
          </div>
          <d-field label="Existing Standards" class="w-5/12 px-5">
            <d-select v-model="newExistingInfo.standards" expanded>
              <option value="AWS, Edition 2">
                Architectural Woodwork Standards: Edition 2 [2019]
              </option>
              <option value="AWS, Edition 1">
                Architectural Woodwork Standards: Edition 1 [2009]
              </option>
            </d-select>
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Project Bid Date" class="w-5/12 px-5">
            <d-datepicker v-model="newSubmittedInfo.projectBidDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
          <d-field label="Submitted Estimated Start of Fabrication" class="w-5/12 px-5">
            <d-datepicker v-model="newSubmittedInfo.estimatedShopDrawingStartDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.estimatedShopDrawingStartDate = newSubmittedInfo.estimatedShopDrawingStartDate" />
            </d-tooltip>
          </div>
          <d-field label="Existing Estimated Start of Fabrication" class="w-5/12 px-5">
            <d-datepicker v-model="newExistingInfo.estimatedShopDrawingStartDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Estimated Completion Date" class="w-5/12 px-5">
            <d-datepicker v-model="newSubmittedInfo.estimatedCompletionDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.estimatedCompletionDate = newSubmittedInfo.estimatedCompletionDate" />
            </d-tooltip>
          </div>
          <d-field label="Existing Estimated Completion Date" class="w-5/12 px-5">
            <d-datepicker v-model="newExistingInfo.estimatedCompletionDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
        </div>

        <div class="flex -mx-5 my-4">
          <d-field label="Submitted Estimated Commencement Date" class="w-5/12 px-5">
            <d-datepicker v-model="newSubmittedInfo.estimatedCommencementDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
          <div class="self-center w-2/12 px-5 text-center">
            <d-tooltip label="Click to move the submitted data">
              <d-icon icon="arrow-right" size="lg" class="cursor-pointer p-2" @click="newExistingInfo.estimatedCommencementDate = newSubmittedInfo.estimatedCommencementDate" />
            </d-tooltip>
          </div>
          <d-field label="Existing Estimated Commencement Date" class="w-5/12 px-5">
            <d-datepicker v-model="newExistingInfo.estimatedCommencementDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
          </d-field>
        </div>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Close
        </d-btn>
        <d-btn type="submit">
          Save Changes
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  export default {
    props: {
      submittedInfo: {
        type: Object,
        default: () => ({}),
      },

      existingInfo: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        newSubmittedInfo: JSON.parse(JSON.stringify(this.submittedInfo)),
        newExistingInfo: JSON.parse(JSON.stringify(this.existingInfo)),
      };
    },

    mounted() {
      this.copyExcessInfo();
    },

    methods: {
      copyExcessInfo() {
        this.newExistingInfo.source = this.newSubmittedInfo.source;
        this.newExistingInfo.id = this.newSubmittedInfo.id;
      },

      saveForm() {
        this.$parent.events.setRevisedInfo(this.newExistingInfo);
        this.$parent.close();
        this.$toast.success('Info has been updated');
      },
    },
  };
</script>